import type { FC } from "react";
import { styled } from "@kivra/react-components";
import { FadeInAndOut } from "../atoms/FadeInAndOut";
import { Instructions } from "./Instructions";

export const Banners: FC = () => (
  <FadeInAndOut>
    <Container>
      <Image src="/assets/onboarding-registration.png" />
      <InstructionWrapper>
        <Instructions />
      </InstructionWrapper>
    </Container>
  </FadeInAndOut>
);

const Container = styled.div({
  position: "relative",
  display: "flex",
});

const InstructionWrapper = styled.div({
  maxWidth: "500px",
  paddingLeft: "$spacing-24",
  paddingRight: "$spacing-24",
});

const Image = styled.img({
  maxWidth: "400px",
  height: "100%",
  marginLeft: "-$spacing-48",
  $medium: {
    maxWidth: "200px",
  },
});
